/**
 * The one locale every date, time and number on screen is formatted in.
 *
 * The interface is written in English, so its dates are too. Passing
 * `undefined` instead hands the choice to the browser, and a browser set to
 * Russian then printed "6 окт. 2026 г." inside an English page.
 */
export const APP_LOCALE = 'en-GB';
